module.exports = __webpack_public_path__ + "static/media/skype.c422810e.svg";